import { css } from 'lit-element';

/*
This file is reserved for any custom css that developers want to add to
customize their theme. Simply add your css to this file and yarn build.
*/

export default css`
    div.nav-bar-path > span {
        font-size: 12px;
    }
    div.nav-bar-path.active > span {
        font-weight: bold;
    }
    div.nav-bar-tag > div {
        color: #2b2b2b;
        font-size: 13px;
    }
    div.collapsed-descr div.key-descr p {
        height: calc(var(--font-size-small) + 6px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .nav-bar-paths-under-tag {
        margin-left: 10px;
    }
    .nav-bar-paths-under-tag:not(.has-active) > div {
        border-left: 4px solid var(--nav-hover-text-color);
    }
    div.nav-bar-tag-and-paths.expanded > div.nav-bar-tag > div {
        color: #FFA306;
        font-weight: semibold;
    }
    .method-fg.post {
        color: #996CB5;
    }
    .method-fg.get {
        color: #4EB38E;
    }
    .method-fg.put {
        color: #66C7D1;
    }
    .method-fg.delete {
        color: #E02020;
    }
    .nav-bar.focused .nav-bar-tag-and-paths.collapsed .nav-bar-tag-icon::after {
      content: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNXB4IiBoZWlnaHQ9IjlweCIgdmlld0JveD0iMCAwIDUgOSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDxnIGlkPSJMZWZ0LU5hdi0tLTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNzYuMDAwMDAwLCAtNTE0LjAwMDAwMCkiIGZpbGw9IiMyQjJCMkIiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgPGcgaWQ9ImNhcmV0LWRvd24tc29saWQtY29weS0zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNzguNTAwMDAwLCA1MTguNTAwMDAwKSByb3RhdGUoLTkwLjAwMDAwMCkgdHJhbnNsYXRlKC0xNzguNTAwMDAwLCAtNTE4LjUwMDAwMCkgdHJhbnNsYXRlKDE3NC4wMDAwMDAsIDUxNi4wMDAwMDApIj4KICAgICAgICAgICAgPHBhdGggZD0iTTAuNTc5MDI2ODQ2LDAgTDcuOTE4MTIwODEsMCBDOC40MjU4Mzg5MywwIDguNjc5Njk3OTksMC42MjM2NDkxODcgOC4zMjAzMDIwMSwwLjk4OTEzNjYxNyBMNC42NTIxODEyMSw0LjcyMjMyOTY2IEM0LjQyOTY5Nzk5LDQuOTQ4NTgzNzggNC4wNjc0NDk2Niw0Ljk0ODU4Mzc4IDMuODQ0OTY2NDQsNC43MjIzMjk2NiBMMC4xNzY4NDU2MzgsMC45ODkxMzY2MTcgQy0wLjE4MjU1MDMzNiwwLjYyMzY0OTE4NyAwLjA3MTMwODcyNDgsMCAwLjU3OTAyNjg0NiwwIFoiIGlkPSJQYXRoIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=");
      width: 5px;
      height: 9px;
      text-align: center;
      display: inline-block;
      transform: unset;
    }
    .nav-bar.focused .nav-bar-tag-and-paths.expanded .nav-bar-tag-icon::after {
      content: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOXB4IiBoZWlnaHQ9IjVweCIgdmlld0JveD0iMCAwIDkgNSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDxnIGZpbGw9IiNGRkEzMDYiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgPHBhdGggZD0iTTAuNTc5MDI2ODQ2LDAgTDcuOTE4MTIwODEsMCBDOC40MjU4Mzg5MywwIDguNjc5Njk3OTksMC42MjM2NDkxODcgOC4zMjAzMDIwMSwwLjk4OTEzNjYxNyBMNC42NTIxODEyMSw0LjcyMjMyOTY2IEM0LjQyOTY5Nzk5LDQuOTQ4NTgzNzggNC4wNjc0NDk2Niw0Ljk0ODU4Mzc4IDMuODQ0OTY2NDQsNC43MjIzMjk2NiBMMC4xNzY4NDU2MzgsMC45ODkxMzY2MTcgQy0wLjE4MjU1MDMzNiwwLjYyMzY0OTE4NyAwLjA3MTMwODcyNDgsMCAwLjU3OTAyNjg0NiwwIFoiIGlkPSJQYXRoIj48L3BhdGg+CiAgICA8L2c+Cjwvc3ZnPg==");
      width: 9px;
      height: 5px;
      text-align: center;
      display: inline-block;
    }
    .expand-collapse:hover {
        color: #FFA306;
        font-weight: semibold;
    }
`;
